"use client";

import Link from "next/link";
import CryptoMarquee from "../cryptoMarquee/CryptoMarquee";
import SocialIcons from "../socialIcons/SocialIcons";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import SubHeader from "../subHeader/SubHeader";
import "./style.css";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import AdSpace from "@/components/ads/Adspace";
import type { MenuItem, MenuResponse } from "@/types/menu";

interface Coin {
  id: string;
  symbol: string;
  name: string;
  image: string;
  current_price: number;
  price_change_percentage_24h: number;
}

export default function Header({
  onHeaderAdChange,
  menu,
  initialCoins = [],
}: {
  onHeaderAdChange?: (exists: boolean) => void;
  menu: MenuItem[];
  initialCoins?: Coin[];
}) {
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme } = useTheme();
  const isDark = mounted ? resolvedTheme === "dark" : false;
  const [headerAdExists, setHeaderAdExists] = useState(false);

  const { theme } = useTheme();
  // const isDark = theme === "dark";

  useEffect(() => {
    setMounted(true);
  }, []);

  const linkColor = isDark ? "#ffffff" : "#000000";

  return (
    <>
      <Navbar
        expand="lg"
        className="py-0 px-md-5 border-bottom nav-bar gh-container"
      >
        {/* <Container fluid className="px-0 d-flex align-items-center"> */}
        <div className="px-3 nav-bar-inner">
          {/* LEFT - Auto Shrink */}
          {/* <div className="grow overflow-hidden left-section me-3"> */}
          <div className="marquee-slot">
            <CryptoMarquee isDark={isDark} initialCoins={initialCoins} />
          </div>

          {/* TOGGLE BUTTON */}
          <Navbar.Toggle aria-controls="header-navbar-nav" className="ms-2" />

          {/* COLLAPSE AREA */}
          <div className="nav-right-slot">
            <Nav className="nav-links-group">
              <Nav.Link
                as={Link}
                href="/advertising"
                className="nav-bar-link"
                style={{ color: linkColor }}
              >
                Advertising
              </Nav.Link>
              <Nav.Link
                as={Link}
                href="/contact-us"
                className="nav-bar-link"
                style={{ color: linkColor }}
              >
                Contact Us
              </Nav.Link>
              <Nav.Link
                as={Link}
                href="/about-us"
                className="nav-bar-link"
                style={{ color: linkColor }}
              >
                About Us
              </Nav.Link>
            </Nav>
            <div className="nav-social-slot">
              <SocialIcons />
            </div>
          </div>
        </div>
      </Navbar>
      <div className="sticky-top">
        <SubHeader menu={menu} />
      </div>
    </>
  );
}
